import { HttpParams } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent, LoaderService } from 'sigv-library';
import {
  SYSTEM_CODE,
  SYSTEM_GROUP_CODE,
} from 'src/app/core/constants/global-constants.constant';
import { ExtranetAuthenticationService } from 'src/app/core/services/extranet-authentication.service';
import { SystemEnvService } from 'src/app/core/services/system-env.service';

@Component({
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent extends BaseComponent implements OnInit {
  constructor(
    injector: Injector,
    private router: Router,
    private extranetAuthenticationService: ExtranetAuthenticationService,
    private loaderService: LoaderService,
    private systemEnvService: SystemEnvService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loaderService.start();

    const allUrls = this.getSystemHostUrls(); // 取得外網且不含自己的系統的系統清單

    const nextUrl = allUrls.shift() as string; // 移除並回傳第一個網址，即下一個要前往的系統網址

    this.extranetAuthenticationService.logout(); // 清除自己系統登入資訊，其他Tab會自動登出

    if (allUrls.length == 0) {
      window.location.href = '/login';  //本身為所有系統清單中的最後一個系統(或是只有一個系統)，導回登入頁 this.router.navigate(['/login']);
    } else {
      window.location.href = this.getNextLogoutUrl(nextUrl, allUrls); // 轉導到下一個登出頁
    }

    this.loaderService.stop();
  }

  private getSystemHostUrls(): string[] {
    const otherUrls = this.getUrlsBySystemCode(SYSTEM_CODE, false);
    const webSubmssionUrl = this.getUrlsBySystemCode(SYSTEM_CODE, true);

    return [...otherUrls, ...webSubmssionUrl]; // 合併系統清單，進件放最後一個
  }

  private getUrlsBySystemCode(systemCode: string, isEqual: boolean): string[] {
    return this.systemEnvService.systemList
      .filter(
        (x) =>
          x.systemGroup === SYSTEM_GROUP_CODE &&
          (isEqual ? x.systemCode === systemCode : x.systemCode !== systemCode)
      )
      .map((systems) => systems.systemHostUrl || '');
  }

  private getNextLogoutUrl(nextUrl: string, systemUrls: string[]): string {
    let queryParameters = new HttpParams();
    queryParameters = queryParameters.set(
      'systemUrls',
      JSON.stringify(systemUrls)
    );

    const url = `${nextUrl}logout?${queryParameters.toString()}`;
    return url;
  }
}
